const state = {
  // 时间配置（window.online 区分线上/测试）
  startDate: window.online ? '2026/10/24' : '2026/10/10',
  endDate: window.online ? '2026/10/26' : '2026/10/12',
  // 显示区域（region_id 数组，空数组表示不限区域）
  regionIds: [3201],
  // 显示图片
  noticeImg:
    'https://gympic.gymcity.com.cn/uploads-edit/202610/btw-event-first-close-notice',
  // 日期角标文案
  closedText: '闭馆', // 闭馆期间（startDate ~ endDate）角标
  openedText: '' // 闭馆结束后角标（当前时间小于endDate时显示，空=不显示）
  // openedText: "营业",           // 闭馆结束后角标（当前时间小于endDate时显示，空=不显示）
}
const mutations = {}
const getters = {}
const actions = {}

export default {
  state,
  mutations,
  actions,
  getters
}
